import { reactive, ref } from "vue";
import { apiService, I18n } from "app-core";
function useForm(schema, initialData) {
  const _initialData = JSON.parse(JSON.stringify(initialData));
  const data = reactive({ ...initialData });
  const busy = ref(false);
  const errors = ref([]);
  function setErrors(serverErrors) {
    errors.value = Object.entries(serverErrors).flatMap(
      ([field, messages]) => (Array.isArray(messages) ? messages : [messages]).map((message) => ({ name: field, message }))
    );
  }
  function clearErrors(field) {
    if (!field) {
      errors.value = [];
    } else {
      errors.value = errors.value.filter((e) => e.name !== field);
    }
  }
  function reset() {
    Object.assign(data, JSON.parse(JSON.stringify(_initialData)));
    errors.value = [];
    busy.value = false;
  }
  function validate() {
    const result = schema.safeParse(data);
    if (result.success) {
      errors.value = [];
      return [];
    }
    errors.value = result.error.issues.map((issue) => ({
      name: issue.path.join(".") || "unknown",
      message: translateZodError(issue)
    }));
    return errors.value;
  }
  async function send(method, url) {
    var _a, _b;
    if (validate().length > 0) {
      throw new Error("Validation failed");
    }
    busy.value = true;
    errors.value = [];
    try {
      return await apiService[method](url, data);
    } catch (error) {
      const serverErrors = (_b = (_a = error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.errors;
      if (serverErrors && typeof serverErrors === "object" && !Array.isArray(serverErrors)) {
        setErrors(serverErrors);
      }
      throw error;
    } finally {
      busy.value = false;
    }
  }
  return {
    data,
    busy,
    errors,
    setErrors,
    clearErrors,
    reset,
    validate,
    post: (url) => send("post", url),
    put: (url) => send("put", url),
    patch: (url) => send("patch", url)
  };
}
function translateZodError(issue) {
  const t = (key, params) => params ? I18n.t(key, params) : I18n.t(key);
  const { code, message } = issue;
  const err = issue;
  switch (code) {
    case "invalid_type":
      if (err.received === "undefined" || err.received === "null") {
        return t("validation.required");
      }
      return t("validation.invalid_type", { expected: err.expected });
    case "too_small":
      if (err.origin === "string") {
        return err.minimum === 1 ? t("validation.required") : t("validation.min_length", { value: err.minimum });
      }
      if (err.origin === "number") {
        return t("validation.min_value", { value: err.minimum });
      }
      if (err.origin === "array") {
        return t("validation.min_items", { min: err.minimum });
      }
      return message;
    case "too_big":
      if (err.origin === "string") {
        return t("validation.max_length", { value: err.maximum });
      }
      if (err.origin === "number") {
        return t("validation.max_value", { value: err.maximum });
      }
      if (err.origin === "array") {
        return t("validation.max_items", { max: err.maximum });
      }
      return message;
    case "invalid_format":
      if (err.format === "email") return t("validation.email");
      if (err.format === "url") return t("validation.url");
      if (err.format === "uuid") return t("validation.uuid");
      return t("validation.general");
    case "invalid_value":
      return t("validation.invalid_enum");
    case "custom":
      return message;
    default:
      return t("validation.general");
  }
}
export {
  useForm as default,
  useForm
};
//# sourceMappingURL=index53.js.map
